export const SET_DASHBOARD_DATA = 'SET_DASHBOARD_DATA';
export const SET_FAVORITES = 'SET_FAVORITES';
export const SET_NONPROFIT_NOT_INTERESTING = 'SET_NONPROFIT_NOT_INTERESTING';
export const HIDE_WELCOME_CARD = 'HIDE_WELCOME_CARD';
export const SET_MEMBER_LOCATIONS = 'SET_MEMBER_LOCATIONS';
export const SET_MEMBER_CURRENT_LOCATION = 'SET_MEMBER_CURRENT_LOCATION';
export const COMPLETE_TASK = 'COMPLETE_TASK';
export const SET_PROFILE_COMPLETION = 'SET_PROFILE_COMPLETION';
export const SET_RECOMENDED_NONPROFIT_TO_FAVORITE = 'SET_RECOMENDED_NONPROFIT_TO_FAVORITE';
export const SET_COUNT_MEMBER_OPPORTUNITY = 'SET_COUNT_MEMBER_OPPORTUNITY';



// WEBPACK FOOTER //
// ./static-content/private/javascripts/store/modules/dashboard/mutation-types.ts